import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import { STATUS } from 'domains/product-pattern/constants'
import StatusBadge from 'domains/product-pattern/atoms/status-badge'
import SelectTableFilter from 'components/atoms/select-table-filter'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

const productPatternTableColumns = ({
  handleEnablePattern,
  handleDisablePattern,
  handleOpenUpdateModal
}) => {

  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }
  StatusFilter.propTypes = filterPropTypes

  const StatusCell = (row) => <StatusBadge status={ row.cell.value } />

  const ImageCell = (row) => <img src={ row.cell.value } width='150' alt='pattern_image'/>

  const ActionCell = ({ cell: { row } }) => (
    <div className='d-flex'>
      {
        row.original.status == STATUS.ENABLED ?
          <RowButton
            data={ row.original }
            color='danger'
            onClick={ handleDisablePattern }
            text='Disable'
          />
          :
          <RowButton
            data={ row.original }
            color='success'
            onClick={ handleEnablePattern }
            text='Enable'
          />
      }
      <RowButton
        data={ row.original }
        color='primary'
        onClick={ handleOpenUpdateModal }
        text='Update'
      />
    </div>
  )

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Label',
        accessor : 'label'
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Cell     : StatusCell,
        Filter   : StatusFilter
      },
      {
        Header         : 'Image',
        accessor       : 'image_url',
        Cell           : ImageCell,
        disableFilters : true
      },
      {
        Header : 'Actions',
        Cell   : ActionCell
      }
    ]
  )
}

export default productPatternTableColumns